import React, { useState } from "react";
import { IoAddCircleOutline } from "react-icons/io5";
import ProductsTable from "./ProductsTable";
import PlanForm from "./CreateProductForm/PlanForm";

// Main component
const CreateProductPlan = ({ products, fetchPlans, stripeData }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleForm = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div className="flex justify-end w-full">
        <button
          onClick={toggleForm}
          className="px-4 py-2 text-xs my-3 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none flex justify-center items-center gap-2"
        >
          <IoAddCircleOutline size={20} />
          Add Plan
        </button>
      </div>
      <div className="w-full overflow-auto max-h-[70vh] ">
        <ProductsTable
          products={products}
          fetchPlans={fetchPlans}
          stripeData={stripeData}
        />
      </div>

      <PlanForm 
        isOpen={isOpen} 
        toggleForm={toggleForm} 
        stripeData={stripeData} 
        fetchPlans={fetchPlans} 
      />
    </div>
  );
};

export default CreateProductPlan; 